import styled from "styled-components";

export const RegisterStyle = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 15px;
`;
